import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=2a5d2222&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=2a5d2222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d2222",
  null
  
)

export default component.exports